import(/* webpackMode: "eager", webpackExports: ["default"] */ "/private/tmp/velova-production-build-95194f1/frontend/app/pricing/pricing-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VelovaNav"] */ "/private/tmp/velova-production-build-95194f1/frontend/components/site/velova-nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VelovaLogo"] */ "/private/tmp/velova-production-build-95194f1/frontend/components/velova-logo.tsx");
;
import(/* webpackMode: "eager" */ "/Users/anmol/Documents/FINAL_OPEN_CLAW/geo/frontend/node_modules/next/dist/client/link.js");
